(function () {
  'use strict';

  function initProduct(section) {
    var productId = section.dataset.productId;
    var colorPos = parseInt(section.dataset.colorPos, 10) || 0;
    var sizePos = parseInt(section.dataset.sizePos, 10) || 0;

    var variantsEl = section.querySelector('[data-variants]');
    if (!variantsEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      console.error('[Ferrier Product] Variant parse error', e);
      return;
    }

    var gallery = section.querySelector('[data-gallery]');
    var slides = Array.from(section.querySelectorAll('.ferrier-product__slide'));
    var dots = Array.from(section.querySelectorAll('[data-dots] .ferrier-product__dot'));

    var colorButtons = Array.from(section.querySelectorAll('.ferrier-product__btn--color[data-color]'));
    var sizeButtons = Array.from(section.querySelectorAll('[data-size]'));
    var variantInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-btn]');
    var btnText = section.querySelector('[data-btn-text]');
    var stockNotice = section.querySelector('[data-stock-notice]');
    var colorLabel = section.querySelector('[data-color-label]');
    var priceEl = section.querySelector('[data-price]');
    var comparePriceEl = section.querySelector('[data-compare-price]');

    // ============================================
    // Helpers
    // ============================================
    function formatMoney(cents) {
      return new Intl.NumberFormat('tr-TR', {style:'currency',currency:'TRY'}).format(cents / 100);
    }

    function getVariantOption(variant, position) {
      if (position === 1) return variant.option1;
      if (position === 2) return variant.option2;
      if (position === 3) return variant.option3;
      return null;
    }

    function findVariant(color, size) {
      return variants.find(function (v) {
        var matchColor = !colorPos || getVariantOption(v, colorPos) === color;
        var matchSize = !sizePos || getVariantOption(v, sizePos) === size;
        return matchColor && matchSize;
      });
    }

    // ============================================
    // State
    // ============================================
    var initialVariant = variants.find(function(v) { return String(v.id) === new URLSearchParams(window.location.search).get('variant'); });
    var state = {
      color: section.querySelector('.ferrier-product__btn--color.is-active')
        ? section.querySelector('.ferrier-product__btn--color.is-active').dataset.color
        : (colorButtons[0] ? colorButtons[0].dataset.color : ''),
      size: initialVariant ? getVariantOption(initialVariant, sizePos) : ''
    };

    // ============================================
    // Galeri — renk filtresi
    // ============================================
    var track = section.querySelector('[data-gallery-track]');
    var galleryIndex = 0;
    var visibleSlides = [];
    var count = section.querySelector('[data-gallery-count]');
    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    function showSlide(index) {
      if (!visibleSlides.length) return;
      galleryIndex = (index + visibleSlides.length) % visibleSlides.length;
      slides.forEach(function(slide) {
        var active = slide === visibleSlides[galleryIndex];
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach(function(dot,i) {
        var active = slides[i] === visibleSlides[galleryIndex];
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (count) count.textContent = (galleryIndex + 1) + ' / ' + visibleSlides.length;
      if (prev) prev.disabled = visibleSlides.length < 2;
      if (next) next.disabled = visibleSlides.length < 2;
    }
    function filterGalleryByColor(color) {
      visibleSlides = slides.filter(function(slide) { return !colorPos || slide.dataset.color === color || slide.dataset.shared === 'true'; });
      slides.forEach(function(slide,i) {
        var hidden = visibleSlides.indexOf(slide) < 0;
        slide.classList.toggle('is-hidden', hidden);
        if (dots[i]) dots[i].classList.toggle('is-hidden', hidden);
      });
      showSlide(0);
    }
    if (prev) prev.addEventListener('click',function(){showSlide(galleryIndex-1);});
    if (next) next.addEventListener('click',function(){showSlide(galleryIndex+1);});
    dots.forEach(function(dot,i){dot.addEventListener('click',function(){showSlide(visibleSlides.indexOf(slides[i]));});});
    if (gallery) gallery.addEventListener('keydown',function(e){
      if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();showSlide(galleryIndex+(e.key==='ArrowRight'?1:-1));}
    });
    var touchStart;
    if (track) {
      track.addEventListener('touchstart',function(e){touchStart={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY};},{passive:true});
      track.addEventListener('touchend',function(e){
        if(!touchStart)return;
        var dx=e.changedTouches[0].clientX-touchStart.x,dy=e.changedTouches[0].clientY-touchStart.y;
        if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))showSlide(galleryIndex+(dx<0?1:-1));
        touchStart=null;
      },{passive:true});
    }

    // ============================================
    // Beden disponibilitesi (renge göre)
    // ============================================
    function updateSizeAvailability() {
      if (!sizePos) return;

      sizeButtons.forEach(function (btn) {
        var size = btn.dataset.size;
        var v = findVariant(state.color, size);

        if (!v || !v.available) {
          btn.classList.add('is-unavailable');
          btn.disabled = true;
        } else {
          btn.classList.remove('is-unavailable');
          btn.disabled = false;
        }
      });

      // Eğer mevcut seçili beden artık unavailable ise temizle
      if (state.size) {
        var currentBtn = sizeButtons.find(function (b) { return b.dataset.size === state.size; });
        if (currentBtn && currentBtn.disabled) {
          currentBtn.classList.remove('is-active');
          state.size = '';
        }
      }
    }

    // ============================================
    // Variant güncelleme (fiyat, stok, button)
    // ============================================
    function updateVariant() {
      var variant = findVariant(state.color, state.size);

      // Renk seçili ama beden seçilmemişse: ilk müsait varyantı bul (sadece display için)
      var displayVariant = variant;
      if (!displayVariant) {
        displayVariant = variants.find(function (v) {
          if (colorPos && getVariantOption(v, colorPos) !== state.color) return false;
          return true;
        });
      }

      if(displayVariant){var url=new URL(window.location.href);url.searchParams.set('variant',displayVariant.id);window.history.replaceState({},'',url);}

      // Fiyat güncelle
      if (displayVariant && priceEl) {
        priceEl.textContent = formatMoney(displayVariant.price);
        if (comparePriceEl) {
          if (displayVariant.compare_at_price > displayVariant.price) {
            comparePriceEl.textContent = formatMoney(displayVariant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
      }

      // Variant ID + button
      if ((!colorPos || state.color) && (!sizePos || state.size)) {
        if (variant && variant.available) {
          variantInput.value = variant.id;
          addBtn.disabled = false;
          btnText.textContent = section.dataset.preorder === 'true' ? 'ÖN SİPARİŞ VER' : 'SEPETE EKLE';
          stockNotice.textContent = '';
          // Düşük stok uyarısı
          if (variant.inventory_quantity && variant.inventory_quantity > 0 && variant.inventory_quantity <= 3) {
            stockNotice.textContent = 'Son ' + variant.inventory_quantity + ' adet';
            stockNotice.classList.add('ferrier-product__stock--low');
          } else {
            stockNotice.classList.remove('ferrier-product__stock--low');
          }
        } else {
          addBtn.disabled = true;
          btnText.textContent = 'TÜKENDİ';
          stockNotice.textContent = '';
        }
      } else if ((!colorPos || state.color) && !state.size && sizePos) {
        addBtn.disabled = true;
        btnText.textContent = 'BEDEN SEÇİN';
        stockNotice.textContent = '';
      } else if (!state.color && colorPos) {
        addBtn.disabled = true;
        btnText.textContent = 'RENK SEÇİN';
        stockNotice.textContent = '';
      }
    }

    // ============================================
    // Renk seçimi
    // ============================================
    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        colorButtons.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed','false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed','true');
        state.color = btn.dataset.color;
        var titleColor = section.querySelector('[data-title-color]');
        if (titleColor) titleColor.textContent = state.color;
        if (colorLabel) colorLabel.textContent = state.color;

        filterGalleryByColor(state.color);
        updateSizeAvailability();
        updateVariant();
      });
    });

    // ============================================
    // Beden seçimi
    // ============================================
    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        sizeButtons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.size = btn.dataset.size;
        updateVariant();
      });
    });

    // ============================================
    // İlk yükleme
    // ============================================
    sizeButtons.forEach(function(btn){btn.classList.toggle('is-active',btn.dataset.size===state.size);});
    filterGalleryByColor(state.color);
    updateSizeAvailability();
    updateVariant();
  }

  function bootstrap() {
    document.querySelectorAll('.ferrier-product').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
